import { render, staticRenderFns } from "./HealthEducationIndex.vue?vue&type=template&id=294bf206&scoped=true"
import script from "./HealthEducationIndex.vue?vue&type=script&lang=js"
export * from "./HealthEducationIndex.vue?vue&type=script&lang=js"
import style0 from "./HealthEducationIndex.vue?vue&type=style&index=0&id=294bf206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294bf206",
  null
  
)

export default component.exports